import React from 'react'
import GoogleMapReact from 'google-map-react'
import { Card, Typography } from '@mui/material'
import { Box } from '@mui/system'

import { ReactComponent as LaCollecteriePointer } from '../../media/halfChair_icon.svg'

const key = 'AIzaSyD75j57gNrdZGu--PT_tRAAJBttmUdA9nc'
const Pointer = ({ text }) => {
	return (
		<Box sx={{ height: 60, display: 'table' }}>
			<Typography sx={{ fontSize: 12 }}>
				<LaCollecteriePointer />
				La Collecterie
				<strong style={{ display: 'block', whiteSpace: 'nowrap' }}>{text}</strong>
			</Typography>
		</Box>
	)
}
const GoogleMaps2 = () => {
	const defaultProps = {
		center: { lat: 48.8615, lng: 2.4467973219086674 },
		fullscreenControl: true,
		mapTypeControl: false,
		streetViewControl: false,
		zoom: 15,
		zoomControl: true,
		maxZoom: 10,
	}

	return (
		// Important! Always set the container height explicitly
		<Card
			sx={(theme) => ({
				width: '100%',
				height: 292,
				borderRadius: (theme) => theme.spacing(2),
				[theme.breakpoints.down('md')]: {
					mt: 10,
				},
			})}
		>
			<GoogleMapReact
				bootstrapURLKeys={{ key }}
				defaultCenter={defaultProps.center}
				defaultZoom={defaultProps.zoom}
			>
				<Pointer lat={48.86529209326748} lng={2.454994151796838} text="Magasin Saint Antoine" />
				<Pointer lat={48.85924680825259} lng={2.4389869284979455} text="La Boutique Dreyfus" />
			</GoogleMapReact>
		</Card>
	)
}

export default GoogleMaps2
